import { date as ZODDate } from 'zod';
import { isTuesday, isWednesday } from 'date-fns';

import { GetScanDataSubmissionsQuery, ScanDataSubmissionsFragment } from '@occc/graphql';

import { FileDisplayStatus } from './scan-data-weekly-file.constants';

import { WEDNESDAY_HOUR_EST_DEADLINE, getEstDateParts } from '../../scan-data.utils';

export const transformDataToScanDataArray = (
  data: GetScanDataSubmissionsQuery,
): ScanDataSubmissionsFragment[] => data.scanDataSubmissions.edges.map((item) => item.node);

export const parseStringToDate = (date: string) => new Date(date);

export const isAValidDate = (value: unknown): value is Date => {
  if (!value) {
    return false;
  }

  if (typeof value === 'number' || typeof value === 'string' || value instanceof Date) {
    return ZODDate().safeParse(new Date(value)).success;
  }

  return false;
};

const TUESDAY_HOUR_EST_START = 8;

export const getFileDisplayStatus = (
  backendStatus: string,
  hasData: boolean,
  currentDate = new Date(),
): FileDisplayStatus => {
  if (backendStatus === 'SUBMITTED') {
    return 'Submitted';
  }

  if (backendStatus === 'SUBMISSION_IN_PROGRESS') {
    return 'Submission in progress';
  }

  const { estDate, hour } = getEstDateParts(currentDate);

  const isWednesdayDay = isWednesday(estDate);
  const isTuesdayDay = isTuesday(estDate);

  if (isWednesdayDay && hour >= WEDNESDAY_HOUR_EST_DEADLINE) {
    return 'Compiling';
  }

  if (isTuesdayDay && hour >= TUESDAY_HOUR_EST_START) {
    if (hasData) {
      return 'Ready to Submit';
    }
    return 'Compiling';
  }

  if (isWednesdayDay && hour < WEDNESDAY_HOUR_EST_DEADLINE) {
    if (hasData) {
      return 'Ready to Submit';
    }
    return 'Compiling';
  }

  return 'Compiling';
};

export const isReadyToSubmit = (displayStatus: FileDisplayStatus): boolean => {
  return displayStatus === 'Ready to Submit';
};
